export default "__VITE_ASSET__CwlGsl9w__"